import { render, staticRenderFns } from "./AvatarChild2.vue?vue&type=template&id=3a8bf2d2&scoped=true&lang=pug"
import script from "./AvatarChild2.vue?vue&type=script&lang=js"
export * from "./AvatarChild2.vue?vue&type=script&lang=js"
import style0 from "./AvatarChild2.vue?vue&type=style&index=0&id=3a8bf2d2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8bf2d2",
  null
  
)

export default component.exports